export const projectStatusKey = 'projectStatus';
